import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Header = styled.div`
  padding: 10px 16px;
  background: ${Colors.GS200};
  border: 1px solid ${Colors.GS300};
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.GS600};
`

export const SuggestionItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid ${Colors.GS300};
  border-top: 0;
  gap: 8px;

  ${mediaQueries.tablet} {
    flex-direction: row;
    align-items: center;
  }
`

export const DomainName = styled.span`
  flex: 1;
`
